import { render, staticRenderFns } from "./GroupCreateLive.vue?vue&type=template&id=349ddff4&scoped=true"
import script from "./GroupCreateLive.vue?vue&type=script&lang=js"
export * from "./GroupCreateLive.vue?vue&type=script&lang=js"
import style0 from "./GroupCreateLive.vue?vue&type=style&index=0&id=349ddff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ddff4",
  null
  
)

export default component.exports